import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCK, BLOCK_GET_DETAIL_STATISTIC, BLOCK_ACTION, BLOCK_DELETE, BLOCK_UPDATE, BLOCK_EDIT_BLOCK, BLOCK_SET_LOADER_STATE, BLOCK_LOADERS } from '../../../store/block';
import { IBlockListingViewModel } from '../../../models/block';
import { isNullOrUndefined } from 'util';
import * as moment from 'moment'
import * as _ from "lodash";
import * as humanizeDuration from 'humanize-duration'
import { CrudStatus } from '../../../common/enums';
import { Uris } from '../../../common/constants';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_GET_DOCUMENTS, DOCUMENT_GET_DOCUMENTS_ATTACHMENTS, DOCUMENT_SET_DOCUMENT_PARAMETER } from '../../../store/document';
import { IDocumentParamter, IDocumentListingViewmodel } from '../../../models/documents';

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const DocumentStore= namespace(DOCUMENT_MODULE_NAMESPACE)

@Component({
  components: {
    'ticket-chart': async () => import('./components/block-ticket-chart/BlockTicketChart.vue'),
    'sub-navigation-title-duplicate': async () => import('@/components/sub-navigation-title-duplicate/SubNavigationTitleDuplicate.vue'),
    'user-profile-enhanced-widget': async () => import('@/components/user-profile-enhanced-widget/UserProfileEnhancedWidget.vue'),
    'user-profile-widget': async () => import('@/components/user-profile-widget/UserProfileWidget.vue'),
    'block-tickets': async () => import('../block-tickets/BlockTickets.vue'),
    'block-infos-loader': async () => import('../loaders/block-infos-loader/BlockInfosLoader.vue'),
    'chart-loader': async () => import('../../home/loaders/chart-loader/ChartLoader.vue')
  },
  filters: {
    attachment_type(name: string){
      if(!name) return ''
      const res= name.split('.')
      if(res && res[1]) return res[1]
      return ''
    }
  }
})
class BlockDetail extends Vue {
  dtStyle: any | null;
  dtChartOptions: any;
  dtCanRender: boolean;
  dtMessageErrorModel: boolean;
  dtError: any;
  dtActionOpen: boolean;
  dtMessageDeleteBlock: boolean
  dtRecentDocuments: IDocumentListingViewmodel[]
  dtFavContacts: any[]
  dtSearchParam: { startDate: string | Date | null, endDate: string | Date | null, blockId: string }
  dtIsLoading: boolean
  dtMenu: boolean;
  _cleatTimeout: any;
  dtTicketChartData:any;

  readonly LOADING_DOCUMENTS: {}[] = Array.from(new Array(3)).map(item=> ({}))
  readonly LOADING_FAVCONTACTS: {}[] = Array.from(new Array(2)).map(item => ({}))


  @BlockStore.Getter currentBlock: IBlockListingViewModel;
  @BlockStore.Getter blockChartsData: {
    amountTicketReported: number
    amountTicketResolved: number
    date: string
  }[];
  @BlockStore.Getter averageResolutionTime: string;
  @BlockStore.Getter blockCrudActionStatus: CrudStatus;
  @BlockStore.Getter blocks: IBlockListingViewModel[];
  @BlockStore.Getter loaders: Map<string,boolean>
  @BlockStore.Getter canManageDocuments: boolean

  @BlockStore.Action(BLOCK_GET_BLOCK)
  storeGetBlockById: (blockId: string) => Promise<any>;

  @BlockStore.Action(BLOCK_GET_DETAIL_STATISTIC)
  storeGetBlockStatisticById: (payload: { blockId: string, start: string, end: string }) => Promise<any>;

  @BlockStore.Action(BLOCK_DELETE)
  storeDeleteBlock: () => Promise<any>

  @BlockStore.Action(BLOCK_UPDATE)
  storeUpdateBlock: () => Promise<any>

  @BlockStore.Mutation(BLOCK_ACTION)
  storeSetBlockAction: (action: CrudStatus ) => void

  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: any, value: boolean }) => void

  @BlockStore.Action(BLOCK_EDIT_BLOCK)
  storeEditBlock: () => void

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_ATTACHMENTS)
  storeGetDocuments: () => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (documentParamter: IDocumentParamter) => void


  /**
   *
   */
  constructor() {
    super();
    this.dtStyle = null;
    this.dtError = null;
    this.dtCanRender = false;
    this.dtMessageErrorModel = false;
    this.dtMenu= false

    this.dtChartOptions = {
      ...require('@/assets/json-resources/chart-options.json')
    }
    const date = moment();
    this.dtSearchParam = {
      startDate:date.startOf('month').add(1,'h').toISOString(),
      endDate: date.endOf('month').toISOString(),
      blockId: null
    }

    this.dtActionOpen= false
    this.dtMessageDeleteBlock= false
    this.dtIsLoading= false
    this.dtRecentDocuments= []
    this.dtFavContacts= []
    this.dtTicketChartData = []
  }


  get coCurrentBlockName(): string {
    if (this.currentBlock)
      return this.currentBlock.name;
    return null;
  }

  get coBlocks() { console.log('bloooocks',this.blocks); return this.blocks };

  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/button').default
    }
  }

  get ref(): string | null {
    return this.currentBlock.block_ref
  }
  get num_apartments(): number {
    return this.currentBlock.totalApartment
  }
  get digicode(): string {
    return this.currentBlock.digicode;
  }
  get address(): any {
    return this.currentBlock.address || {};
  }
  get location() {
    if (isNullOrUndefined(this.address.lat))
      return null;
    return {
      lat: Number(this.address.lat),
      lng: Number(this.address.lng),
    }
  }
  get coCaretakers() {
    console.log('current block daaata',this.currentBlock)
    return (this.currentBlock.caretakers || []).map(x => this.mapToResource(x).next().value);
  }
  get hasCaretaker(): string {
    return this.coCaretakers.length > 0 ? 'oui' : 'non'
  }

  get isOpenDeleteMessage() : boolean {
    return this.blockCrudActionStatus === CrudStatus.Delete
  }

  get favContacts() : any[] {
    return (this.currentBlock.managers || [])
                  .concat(this.currentBlock.salespersons || [])
                  .map(contact => ({
                    ...contact,
                    fullname: contact.fullname || `${contact.firstname} ${contact.lastname}`.trim()
                  }))
  }

  get favContactsIndexer() {
    return this.coInfosLoader ? this.LOADING_FAVCONTACTS : this.favContacts.map((contact,index) => index).filter(index => index % 2 === 0)
  }

  get coInfosLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.INFOS)
  }

  get coChartsLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.CHARTS)
  }

  get coDocumentsLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.DOCUMENTS)
  }

  get coFilterLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.FILTER)
  }

  handleBlockClick(event: { data: any, index: number }) {
    clearTimeout(this._cleatTimeout)
    this._cleatTimeout = setTimeout(() => {
      this.dtMenu = false;
      this.$router.push({
        path: `/block/${event.data.id}`,
        params: {
          id: event.data.id
        }
      })
    }, 300);
  }

  getStatisticResolvedOptions(key: "blockReportedTicketStatistic" | "blockResolvedTicketStatistic") {
    return {
      ...this.dtChartOptions,
      title: this.$t(this.lblSetting[key], { days: 30 })
    }
  }
  get coStatisticResolvedData(): any {
    return this.getChartData('amountTicketResolved')
  }
  get coStatisticReportedData(): any {
    return this.getChartData('amountTicketReported')
  }

  *mapToResource(x) {
    const avatar = `${(x.firstname || '').substring(0, 1)} ${(x.lastname || '').substring(0, 1)}`;
    yield {
      firstname: x.firstname,
      lastname: x.lastname,
      email: x.email,
      landline: x.landline,
      cellphone: x.cellphone,
      id: x.id,
      avatar: avatar.trim().replace(' ', '/')
    }
  }
  getChartData(key: "amountTicketResolved" | "amountTicketReported") {
    return [
      ['Number', '', { role: 'style' }],
      ...this.blockChartsData.map(x => {
        let label: string = '';
        const dateMoment = moment(x.date);
        if (dateMoment.get('date') % 5 === 0) {
          label = dateMoment.format('DD');
        }
        return [label, x[key], `color: ${key === "amountTicketReported" ? '#f92ac2' : '#00f4d9'};`]
      })
    ]
  }

  initMapContainer() {
    let intervalMapTracer: any;
    let isCleared: boolean;
    this.$nextTick(() => {
      isCleared = false;
      if (!isCleared) {
        clearInterval(intervalMapTracer);
        let mainContainer = document.getElementsByClassName('main-container')[0];
        if (mainContainer) {
          let width: number = ((mainContainer.clientWidth - 500) / 4);
          this.dtStyle = {
            width: width + 'px !important',
            'min-width': width + 'px !important',
            'max-width': width + 'px !important',
            height: width + 'px  !important',
            'min-height': width + 'px  !important',
            'max-height': width + 'px  !important'
          }

        }
      }

    })
  }

  get path(): string {
    return '/block/' + this.$route.params.id
  }
  get coTicketChartData():any {
    return this.ticketChartData()
  }

  get coRecentDocs(): any[] {
    return this.coDocumentsLoader ? this.LOADING_DOCUMENTS: this.dtRecentDocuments
  }

  created() {
    console.log('route block id',this.$route.params.id)
    if(this.canManageDocuments) this.getDocumentsByBlockId(this.$route.params.id)
  }

  mounted() {
    //@ts-ignore

    this.dtSearchParam.blockId = this.$route.params.id;
    this.storeSetLoaderState({ key: BLOCK_LOADERS.INFOS, value: true })
    this.storeGetBlockById(this.$route.params.id)
      .then(res => {
        this.dtCanRender = true;
        this.dtMessageErrorModel = false;
      })
      .catch(err => {
        this.dtCanRender = false;
        this.dtMessageErrorModel = true;
        this.dtError = err;
      })
      .finally(() => { this.storeSetLoaderState({ key: BLOCK_LOADERS.INFOS, value: false }) })

    this.handleLoadStatisticData()
    this.$watch('$route.params', (n, o) => this.handleLoadStatisticData())
    this.initMapContainer();
    if (this.path === this.$route.fullPath) {
      window.onresize = () => this.initMapContainer();
    }
  }

  getDocumentsByBlockId(id: string){
    console.log('route block id',this.$route.params.id)
    this.storeSetDocumentParameter(
      {
        block: [parseInt(id)],
        apartment: [],
        detail: "list",
        orderKeys: ["createdAt"],
        orderValues: [-1],
        fk_attachment_type: [],
        $skip:0,
        $limit: 3
      })

    this.storeSetLoaderState({ key: BLOCK_LOADERS.DOCUMENTS, value: true })
    this.storeGetDocuments()
      .then(documents => {
         this.dtRecentDocuments= documents.data.slice(0,3).map(document => ({
           ...document,
           when: this.getDateDuration(document.createdAt)
         }))
         this.storeSetLoaderState({ key: BLOCK_LOADERS.DOCUMENTS, value: false })
      })
      .finally(() => {
        this.storeSetDocumentParameter({
          $limit: 10
        })
      })
  }

  getDateDuration(creation: string){
    const duration: string= humanizeDuration(Date.now() - new Date(creation).getTime(), { language: this.$i18n.locale  })
    const durationMain= duration.split(',')[0]
    return durationMain
  }
  handleLoadStatisticData() {
    this.storeSetLoaderState({ key: BLOCK_LOADERS.CHARTS, value: true })
    this.storeGetBlockStatisticById({
      blockId: this.$route.params.id,
      start: moment(this.dtSearchParam.startDate).format('YYYY-MM-DD'),
      end: moment(this.dtSearchParam.endDate).format('YYYY-MM-DD')
    })
    .then((res)=>{
       this.storeSetLoaderState({ key: BLOCK_LOADERS.CHARTS, value: false });
       this.dtTicketChartData = res.chartsByDay;
    })
  }
  _clearTimeout: any;
  handleChange(event) {
    this._clearTimeout = setTimeout(() => {
      this.handleLoadStatisticData();
    }, 300);
  }


  handleGoBack() {
    this._clearTimeout = setTimeout(() => {
      this.$router.go(-1);
    }, 300);
  }

  handleEditBlock(){
    this.dtActionOpen= false
    this.storeEditBlock()
  }

  handleDeleteBlock(){
    this.storeSetBlockAction(CrudStatus.Delete)
    this.dtActionOpen= false
  }

  handleDeleteCancel(){
    this.storeSetBlockAction(CrudStatus.NoAction)
  }

  handleDeleteOK(){
    this.dtIsLoading= true
    this.storeDeleteBlock()
    .then(()=>{
      this.dtIsLoading= false
      this.$router.replace(`${Uris.Block}`)
    })
    .catch(err=>{
      this.dtMessageErrorModel= true
      this.dtError= err
    })
    .finally(()=>{
      this.dtActionOpen= false
    })
  }

  handleCloseErrorModal(){
    this.dtError= null
    this.dtMessageErrorModel= false
  }

  handleViewDocument(e:Event,link: string){
    e.preventDefault()
    if(link) window.open(link)
  }

  ticketChartData(){
    let source = this.dtTicketChartData;
    let sumAmountTicketReported = 0;
    let sumAmountTicketResolved = 0;
    for (let i = 0; i < source.length; i++) {
      sumAmountTicketReported += source[i].amountTicketReported;
      sumAmountTicketResolved += source[i].amountTicketResolved;
    }
     let chartData =  {
     ticket :  [
      ["Elément", "%"],
        [`Ouverts (${sumAmountTicketReported})`, sumAmountTicketReported],
        [`Clôturés (${sumAmountTicketResolved})`,sumAmountTicketResolved]
      ]
     }
    return  chartData
  }
  
  ticketChartDataOptions() {
    return {
      backgroundColor: "transparent",
      fontSize:12,
      fontName:'Raleway',
      tooltip: {
        textStyle:{
          color: "#2E038C",
          fontSize: 12,
          bold: false,
          fontName: "Raleway"
        }
      },
      legend: {
        position: 'bottom',
        alignment: 'center',
        textStyle:{
          color: "#000",
          fontSize: 12,
          bold: false,
          fontName: "Raleway"
        }
      },
      chartArea: { width: '100%' },
      pieHole: 0.3,
      hAxis: {
        minValue: 0,
      },
      height: 180,
      colors: ['#f92ac2','#00f4d9'],
      pieSliceText: 'value-and-percentage',
    };
  }
}

export default BlockDetail;



// WEBPACK FOOTER //
// ./src/containers/block/block-detail/index.ts